// extracted by mini-css-extract-plugin
module.exports = {"button":"IconButton_button__1Jn5m"};